// // Mega Menu Image Code

// let defaultImage = document.getElementById("megaMenuImage").src;

// function updateMegaMenuImage(imageUrl) {
//   let imageElement = document.getElementById("megaMenuImage");
//   if (imageUrl && imageUrl !== "null") {
//     imageElement.src = imageUrl;
//   }
// }

// function resetMegaMenuImage() {
//   document.getElementById("megaMenuImage").src = defaultImage;
// }

// Mega Menu Image Code
document.addEventListener("DOMContentLoaded", function () {
  let imageElement = document.getElementById("megaMenuImage");

  if (!imageElement) {
    console.warn("Mega Menu Image element not found.");
    return; // Exit script if the image element is missing
  }

  let defaultImage = imageElement.src;

  function updateMegaMenuImage(imageUrl) {
    if (imageUrl && imageUrl !== "null") {
      imageElement.src = imageUrl;
    }
  }

  function resetMegaMenuImage() {
    imageElement.src = defaultImage;
  }

  // Expose functions to the global scope if needed
  window.updateMegaMenuImage = updateMegaMenuImage;
  window.resetMegaMenuImage = resetMegaMenuImage;
});

